/**
 * The first line of a block of text, for teaser previews.
 *
 * The public business and education pages show logged-out visitors a taste of
 * each review rather than the whole thing, so this cuts at the first line
 * break. Pair it with `line-clamp-1`: a review written as one long paragraph
 * has no break to cut at, and only the clamp keeps that to a single rendered
 * line.
 */
export function firstLine(text: string | undefined | null): string {
  return (text ?? '').split(/\r?\n/, 1)[0].trim();
}
